export default class Replenishemt extends HTMLElement {
	constructor() {
		super();
		this.products = JSON.parse(this.dataset.products);
		this.elMsgError = this.querySelector('[data-msg-error]');
		this.elMsgSuccess = this.querySelector('[data-msg-success]');
		this.orderId = this.dataset.orderId;
	}

	connectedCallback() {
		this.addEventListener('click', () => {
			this.handleProducts();
		});
	}

	handleProducts() {
		let productsToAdd = [];
		let productsToWarn = [];

		this.products.forEach((product) => {
			const item_in_cart = Number(product.item_in_cart);
			const inventory_quantity = Number(product.inventory_quantity);
			const quantity = Number(product.quantity);
			const available = product.available === true;
			const {
				stringMsgNotavailable,
				stringMsgOutofstock,
				stringMsgQtyreached,
				stringMsgOnlyqtyleft,
			} = this.dataset;

			if (typeof product.id !== 'number' || !available) {
				product.reason = `${stringMsgNotavailable.replace(
					'{{ title }}',
					product.title,
				)}`;
				productsToWarn.push(product);
			} else if (inventory_quantity === 0) {
				product.reason = `${stringMsgOutofstock.replace(
					'{{ title }}',
					product.title,
				)}`;
				productsToWarn.push(product);
			} else if (item_in_cart >= inventory_quantity) {
				product.reason = `${stringMsgQtyreached.replace(
					'{{ title }}',
					product.title,
				)}`;
				productsToWarn.push(product);
			} else if (quantity > inventory_quantity) {
				product.quantity = product.inventory_quantity;
				productsToAdd.push(product);
				product.reason = `${stringMsgOnlyqtyleft
					.replace('{{ title }}', product.title)
					.replace('{{ inventory_quantity }}', product.inventory_quantity)}`;
				productsToWarn.push(product);
			} else {
				productsToAdd.push(product);
			}
		});

		if (productsToAdd.length > 0) this.addToCart(productsToAdd, productsToWarn);
		if (productsToWarn.length > 0) this.showWarningMsg(productsToWarn);
	}

	addToCart(productsToAdd, productsToWarn) {
		let formData = {
			items: [],
			sections: this.getSectionsToRender().map((section) => section.section),
			sections_url: window.location.pathname,
		};

		productsToAdd.forEach((product) => {
			formData.items.push({
				id: product.id,
				quantity: product.quantity,
			});
		});

		fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(formData),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				// Render the sections if no error happens
				if (data.status == undefined) {
					const parsedState = data;

					this.getSectionsToRender().forEach((section) => {
						const elementToReplace =
							document
								.getElementById(section.id)
								.querySelector(section.selector) ||
							document.getElementById(section.id);
						elementToReplace.innerHTML = this.getSectionInnerHTML(
							parsedState.sections[section.section],
							section.selector,
						);
					});

					this.showSuccessMsg();
					if (productsToWarn.length > 0) this.showWarningMsg(productsToWarn);

					// Open the cart drawer
					const cartDrawer = document.querySelector('cart-drawer');
					cartDrawer.classList.remove('is-empty');
					const cartDrawerOverlay = document.querySelector(
						'#CartDrawer-Overlay',
					);
					if (cartDrawer && cartDrawerOverlay) {
						cartDrawer.open();
						cartDrawerOverlay.addEventListener('click', () =>
							cartDrawer.close(),
						);
					}
				}

				// Show error message if the response has a status -- this case should not happen
				if (data.status && data.status !== 200) {
					this.elMsgError.removeAttribute('hidden');
					this.elMsgError.innerText = data.message;
					setTimeout(() => {
						this.elMsgError.setAttribute('hidden', '');
					}, 3000);
				}
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}

	showSuccessMsg() {
		const stringMsgSuccess = this.dataset.stringMsgSuccess;

		const elMsgSuccess = document.querySelector(
			`[data-msg-success="${this.orderId}"]`,
		);
		elMsgSuccess.removeAttribute('hidden');

		const msgSuccess = document.createElement('p');
		msgSuccess.classList.add('u-block');
		msgSuccess.innerText = stringMsgSuccess;
		elMsgSuccess.innerText = msgSuccess.innerText + '\n';

		setTimeout(() => {
			elMsgSuccess.setAttribute('hidden', '');
		}, 3000);
	}

	showWarningMsg(productsToWarn) {
		const elMsgError = document.querySelector(
			`[data-msg-error="${this.orderId}"]`,
		);
		elMsgError.innerText = '';
		elMsgError.removeAttribute('hidden');

		productsToWarn.forEach((product) => {
			const msgError = document.createElement('p');
			msgError.classList.add('u-block');
			msgError.innerText = product.reason;
			elMsgError.innerText += msgError.innerText + '\n';
		});

		setTimeout(() => {
			elMsgError.setAttribute('hidden', '');
		}, 3000);
	}

	getSectionsToRender() {
		const arraySections = [
			{
				id: 'CartDrawer',
				section: 'cart-drawer',
				selector: '#CartDrawer',
			},
			{
				id: 'cart-icon-bubble',
				section: 'cart-icon-bubble',
				selector: '.shopify-section',
			},
			{
				id: 'announcement-bar',
				section: document.getElementById('announcement-bar')?.dataset.id,
				selector: '.js-contents-announcement',
			},
		];

		if (window.location.pathname == '/pages/orders') {
			arraySections.push({
				id: 'main-account',
				section: 'page-orders',
				selector: '#main-account',
			});
		} else {
			arraySections.push({
				id: 'main-account',
				section: 'main-order',
				selector: '#main-account',
			});
		}

		return arraySections;
	}

	getSectionInnerHTML(html, selector) {
		return new DOMParser()
			.parseFromString(html, 'text/html')
			.querySelector(selector).innerHTML;
	}
}
